// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_sl-0";
export var checkoutRateBadgeLink = "_sl-1";